<template>
<div class="app-container page-list">
  <div class="page-list-filter">
    <el-row>
      <el-col :span="6">
        <div class="grid-content bg-purple">
          <el-input class="page-list-filter-value" v-model.trim="search.name" @keyup.enter.native="searchChange" placeholder="名字" clearable size="small" suffix-icon="el-icon-search"></el-input>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple">
          <el-input class="page-list-filter-value" v-model.trim="search.description" @keyup.enter.native="searchChange" placeholder="描述" clearable size="small" suffix-icon="el-icon-search"></el-input>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple">
          <el-input class="page-list-filter-value" v-model.trim="search.code" @keyup.enter.native="searchChange" placeholder="标识" clearable size="small" suffix-icon="el-icon-search"></el-input>
        </div>
      </el-col>
      <el-col :span="6">
        <div>
          <el-button class="page-list-filter-reset" size="small" @click="searchReset">清除条件</el-button>
          <el-button class="page-list-filter-search" size="small" @click="searchChange">立即筛选</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
  <basic-container class="page-list-container">
    
    <avue-crud
      ref="crud"
      :option="basicPageOption"
      :table-loading="loading"
      :data="tableData"
      :page="page"
      :before-open="handleOpenBefore"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      @refresh-change="refreshChange">
      <template slot="menuLeft">
          <el-button 
            v-if="permissions.basic_page_add" 
            type="primary" 
            size="small" 
            @click="handleAdd" 
            icon="el-icon-plus">新增网页素材
          </el-button>
      </template>

      <template slot="code"
                  slot-scope="scope">
          <div class="link">
            <a @click.stop.prevent="copyText(scope.row.code)" href="#">复制链接</a>{{scope.row.code}}
          </div>
      </template>
      <template slot="menu"
        slot-scope="scope">
        <el-button size="mini"
          type="text"
          icon="el-icon-view"
          @click="handleView(scope.row,scope.index)">
          查看
        </el-button>
        <el-button size="mini" 
          type="text" 
          icon="el-icon-edit"
          @click="handleEdit(scope.row,scope.index)"
          v-if="permissions.basic_page_edit">编辑
        </el-button>
        <el-button size="mini" 
          type="text" 
          icon="el-icon-delete"
          @click="handleDelete(scope.row,scope.index)"
          v-if="permissions.basic_page_delete">删除
        </el-button>
        <el-button size="mini" 
          type="text"
          icon="el-icon-share"
          @click.stop.prevent="copyText(scope.row.code)">复制链接
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</div>
</template>

<script>
  import {
    fetchList,
    addBasicPage,
    editBasicPage,
    deleteBasicPage,
    getBasicPageById,
  } from "@/api/basic/basicpage";
  import { basicPageOption } from "@/const/crud/basic/basicpage";
  import { mapGetters } from "vuex";
  export default {
    data() {
      return {
        page: {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 20, // 每页显示多少条,
        },
        params: {},
        search: {
          id: '',
          name: '',
          description: '',
          content: '',
          contentType: '',
          code: ''
        },
        loading: false,
        tableData: [],
        basicPageOption: basicPageOption,
      };
    },
    created() {
      this.getList();
    },
    computed: {
      ...mapGetters(["permissions"]),
    },
    methods: {
      copyText(text) {
        text = process.env.VUE_APP_BASIC_PAGE_PATH+`/material/page/${text}`
        this.$copyText(text).then(
          res => {
            this.$message({
              showClose: true,
              type: 'success',
              message: '已成功复制'
            })
          },
          err => {
            this.$message({
              showClose: true,
              type: 'error',
              message: '失败'
            })
          }
		    )
      },
      handleOpenBefore(show, type) {
        show();
      },
      getList() {
        this.loading = true;
        let params = {
          size: this.page.pageSize,
          current: this.page.currentPage,
          id: this.search.id,
          name: this.search.name,
          description: this.search.description,
          content: this.search.content,
          contentType: this.search.contentType,
          code: this.search.code
        };
        fetchList(params).then((res) => {
          this.tableData = res.data.data.records;
          this.loading = false;
          this.page.total = res.data.data.total;
        });
      },
      handleAdd(row, done, loading) {
        this.$router.push({
          path: '/basicpage/add'
        })
      },
      handleEdit(row) {
        this.$router.push({
          path: '/basicpage/edit', query: {id: row.id}
        })
      },
      handleDelete(row) {
        this.$confirm('此操作将永久删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return deleteBasicPage(row.id);
          })
          .then(() => {
            this.$message.success('删除成功');
            this.getList();
          });
      },
      searchChange() {
        this.page.currentPage = 1;
        this.getList();
        this.$message.success('搜索成功');
      },
      searchReset() {
        this.page.currentPage = 1;
        this.search.id = '';
        this.search.name = '';
        this.search.description = '';
        this.search.content = '';
        this.search.contentType = '';
        this.search.code = '';
        this.getList();
      },
      handleCurrentChange(val) {
        this.page.currentPage = val;
        this.getList();
      },
      handleSizeChange(val) {
        this.page.currentPage = 1;
        this.page.pageSize = val;
        this.getList();
      },
      refreshChange() {
        this.getList();
        this.$message.success('刷新成功');
      },
      handleView(row, index) {
        if (row.id){
          this.$router.push({
            path: `/basicpage/detail/${row.id}`
          })
        } else {
          this.$message({
            showClose: true,
            message: '网页素材不存在',
            type: 'warning'
          })
        }
      }
    },
  };
</script>
<style lang="scss" scoped>
.page-list {
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      border: none;
      font-size: 14px;
    }
    .el-row {
      width: 95%;
    }
    &-value {
      width: calc(100% - 12px) !important;
    }
    &-reset {
      margin-left: 10px;
    }
    &-search {
      margin-left: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }

  &-container {
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 170px;
      text-align: left;
    }
  }
}
.link {
  a {
    color: #5383F3;
    padding-right: 8px;
  }
}
</style>
